import React, { Component } from 'react';

import GridList, { GridListTile } from 'material-ui/GridList';
import Hidden from 'material-ui/Hidden';

import gallery01 from '../images/gallery/gallery01.jpg';
import gallery02 from '../images/gallery/gallery02.jpg';
import gallery03 from '../images/gallery/gallery03.jpg';
import gallery04 from '../images/gallery/gallery04.jpg';
import gallery05 from '../images/gallery/gallery05.jpg';
import gallery06 from '../images/gallery/gallery06.jpg';
import gallery07 from '../images/gallery/gallery07.jpg';
import gallery08 from '../images/gallery/gallery08.jpg';
import gallery09 from '../images/gallery/gallery09.jpg';
import gallery10 from '../images/gallery/gallery10.jpg';
import gallery12 from '../images/gallery/gallery12.jpg';
import gallery13 from '../images/gallery/gallery13.jpg';
import gallery14 from '../images/gallery/gallery14.jpg';
import gallery15 from '../images/gallery/gallery15.jpg';
import gallery16 from '../images/gallery/gallery16.jpg';
import gallery17 from '../images/gallery/gallery17.jpg';
import gallery18 from '../images/gallery/gallery18.jpg';
import gallery19 from '../images/gallery/gallery19.jpg';
import gallery20 from '../images/gallery/gallery20.jpg';
import gallery21 from '../images/gallery/gallery21.jpg';
import gallery22 from '../images/gallery/gallery22.jpg';
import gallery23 from '../images/gallery/gallery23.jpg';
import gallery24 from '../images/gallery/gallery24.jpg';
import gallery25 from '../images/gallery/gallery25.jpg';
import gallery26 from '../images/gallery/gallery26.jpg';
import gallery27 from '../images/gallery/gallery27.jpg';
import gallery28 from '../images/gallery/gallery28.jpg';
import gallery29 from '../images/gallery/gallery29.jpg';


class Gallery extends Component {

  render() {
    const imageData = [
      {
        img: gallery01,
        title: 'gallery01',
        cols: 2,
      },
      {
        img: gallery02,
        title: 'gallery02',
        cols: 1,
      },
      {
        img: gallery03,
        title: 'gallery03',
        cols: 1,
      },
      {
        img: gallery04,
        title: 'gallery04',
        cols: 1,
      },
      {
        img: gallery05,
        title: 'gallery05',
        cols: 1,
      },
      {
        img: gallery06,
        title: 'gallery06',
        cols: 1,
      },
      {
        img: gallery07,
        title: 'gallery07',
        cols: 2,
      },
      {
        img: gallery08,
        title: 'gallery08',
        cols: 2,
      },
      {
        img: gallery09,
        title: 'gallery09',
        cols: 1,
      },
      {
        img: gallery10,
        title: 'gallery10',
        cols: 1,
      },
      {
        img: gallery12,
        title: 'gallery12',
        cols: 2,
      },
      {
        img: gallery13,
        title: 'gallery13',
        cols: 1,
      },
      {
        img: gallery14,
        title: 'gallery14',
        cols: 1,
      },
      {
        img: gallery15,
        title: 'gallery15',
        cols: 1,
      },
      {
        img: gallery16,
        title: 'gallery16',
        cols: 1,
      },
      {
        img: gallery17,
        title: 'gallery17',
        cols: 2,
      },
      {
        img: gallery18,
        title: 'gallery18',
        cols: 1,
      },
      {
        img: gallery19,
        title: 'gallery19',
        cols: 1,
      },
      {
        img: gallery20,
        title: 'gallery20',
        cols: 1,
      },
      {
        img: gallery21,
        title: 'gallery21',
        cols: 2,
      },
      {
        img: gallery22,
        title: 'gallery22',
        cols: 1,
      },
      {
        img: gallery23,
        title: 'gallery23',
        cols: 1,
      },
      {
        img: gallery24,
        title: 'gallery24',
        cols: 1,
      },
      {
        img: gallery25,
        title: 'gallery25',
        cols: 1,
      },
      {
        img: gallery26,
        title: 'gallery26',
        cols: 1,
      },
      {
        img: gallery27,
        title: 'gallery27',
        cols: 2,
      },
      {
        img: gallery28,
        title: 'gallery28',
        cols: 1,
      },
      {
        img: gallery29,
        title: 'gallery29',
        cols: 2,
      }
    ];
    return (
      <div className="gallery">
        <Hidden smDown>
          <GridList cellHeight={480}cols={3}>
            {imageData.map(tile => (
              <GridListTile key={tile.img} cols={tile.cols || 1}>
                <img src={tile.img} alt={tile.title}/>
              </GridListTile>
            ))}
          </GridList>
        </Hidden>
        <Hidden mdUp>
          <GridList cellHeight={180}cols={3}>
            {imageData.map(tile => (
              <GridListTile key={tile.img} cols={tile.cols || 1}>
                <img src={tile.img} alt={tile.title} />
              </GridListTile>
            ))}
          </GridList>
        </Hidden>
      </div>
    )
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.js